module.exports = __webpack_public_path__ + "img/edge-filter-applied.b12cfcfa.jpg";